import { Component } from '@angular/core';

import { RouterModule, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  standalone: true,
  imports: [RouterOutlet,RouterModule],
})
export class PublicLayoutComponent { }
